import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/walletTransactions',
        name: 'walletTransactions',
        meta: { sideMenuLabel: "Movimenti Wallet" },
        component: () => import("./views/walletTransactions.vue")
    },
];

export default routes;